import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal/LegalPage";
import { PrivacyPolicy } from "@/components/legal/LegalModal";

export const Route = createFileRoute("/integritetspolicy")({
  head: () => ({
    meta: [
      { title: "Integritetspolicy | Sellavo" },
      { name: "description", content: "Så behandlar Sellavo personuppgifter, bilder, platsuppgifter och kontoinformation enligt GDPR." },
      { property: "og:title", content: "Integritetspolicy | Sellavo" },
      { property: "og:description", content: "Så behandlar Sellavo dina personuppgifter enligt GDPR." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://sellavo.com/integritetspolicy" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/integritetspolicy" }],
  }),
  component: () => (
    <LegalPage title="Integritetspolicy" intro="Här beskriver vi vilka personuppgifter vi behandlar, varför vi gör det och vilka rättigheter du har.">
      <PrivacyPolicy />
    </LegalPage>
  ),
});